// extracted by mini-css-extract-plugin
module.exports = {"badge":"column-clinical-meeting-activities_badge__1vi8G"};